<template>
  <ul class="list-inline">
    <li><share-pinterest :url="url" :image-url="imageUrl" :description="description"></share-pinterest></li>
    <li><share-facebook :facebook-app-id="facebookAppId" :url="url" :image-url="imageUrl" :description="description"></share-facebook></li>
    <li><share-twitter :url="url" :image-url="imageUrl" :description="description"></share-twitter></li>
  </ul>
</template>

<style scoped>
</style>

<script>
import ShareFacebook from './ShareFacebook'
import SharePinterest from './SharePinterest'
import ShareTwitter from './ShareTwitter'

export default {
    components: {
        'share-facebook': ShareFacebook,
        'share-pinterest': SharePinterest,
        'share-twitter': ShareTwitter,
    },

    props: {
        facebookAppId: {
            type: String,
            default: window.jrConfig.facebookAppId,
        },
        url: {
            type: String,
            default: ''
        },
        imageUrl: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
    },

    methods: {
        href: function () {
            return 'https://www.pinterest.com/pin/create/button/?url=' + urlencode(this.url) +
                '&media=' +  urlencode(this.imageUrl) +
                '&description=' + urlencode(this.description)
        }
    },
}
</script>
